import usePageTitle from "@/hooks/usePageTitle";
import { Navigate, useLocation } from "react-router-dom";

export default function ConfigurationIndexPage() {
  usePageTitle("/configuration", "Member 360 Configuration");
  const location = useLocation();

  return <Navigate to={`${location.pathname}/career-consultants`} replace />;
}
